import { MessageCircle, Phone, Instagram, MapPin, Clock } from "lucide-react";
import { BUSINESS, IMAGES } from "../data";

export default function Contact() {
  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="relative py-24 sm:py-32 bg-[#0A0C10] overflow-hidden"
    >
      <div className="absolute inset-0 opacity-25">
        <img
          src={IMAGES.exterior}
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0A0C10] via-[#0A0C10]/90 to-[#0A0C10]/50" />
      </div>

      <div
        aria-hidden="true"
        className="absolute right-0 bottom-0 h-[420px] w-[420px] rounded-full bg-[#00F0FF]/15 blur-[140px]"
      />

      <div className="relative max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 grid grid-cols-1 lg:grid-cols-12 gap-10">
        <div className="lg:col-span-6">
          <div className="text-[11px] uppercase tracking-[0.24em] text-[#00F0FF] mb-5">
            / Get in touch
          </div>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-medium text-white tracking-tighter leading-[1.05]">
            Tell us about your car.{" "}
            <span className="text-gradient-cyan">We'll do the rest.</span>
          </h2>
          <p className="mt-6 max-w-md text-[#9CA3AF] leading-relaxed">
            WhatsApp is the fastest way to reach us — send a message with your
            car, the job and a couple of photos. We'll quote you back the same
            day.
          </p>

          <div className="mt-10 flex flex-wrap gap-3">
            <a
              href={BUSINESS.whatsappText}
              target="_blank"
              rel="noreferrer"
              data-testid="contact-whatsapp-cta"
              className="inline-flex items-center gap-2 bg-[#00F0FF] hover:bg-[#33F3FF] text-[#0A0C10] font-semibold text-sm px-6 py-3.5 rounded-sm transition-all hover:shadow-[0_0_30px_rgba(0,240,255,0.3)]"
            >
              <MessageCircle className="h-4 w-4" />
              Message on WhatsApp
            </a>
            <a
              href={BUSINESS.phoneHref}
              data-testid="contact-call-cta"
              className="inline-flex items-center gap-2 border border-white/15 text-white hover:bg-white/5 px-6 py-3.5 rounded-sm text-sm font-medium transition-colors"
            >
              <Phone className="h-4 w-4" />
              Call {BUSINESS.phone}
            </a>
          </div>
        </div>

        <div className="lg:col-span-6 grid grid-cols-1 sm:grid-cols-2 gap-4 lg:pt-4">
          <ContactCard
            icon={Phone}
            label="Phone & WhatsApp"
            value={BUSINESS.phone}
            href={BUSINESS.whatsappText}
            testId="contact-card-phone"
          />
          <ContactCard
            icon={Instagram}
            label="Instagram"
            value={BUSINESS.instagramHandle}
            href={BUSINESS.instagram}
            testId="contact-card-instagram"
          />
          <ContactCard
            icon={MapPin}
            label="Based in"
            value={`${BUSINESS.location} · Fully mobile across Greater London`}
            testId="contact-card-location"
          />
          <ContactCard
            icon={Clock}
            label="Opening hours"
            value={BUSINESS.hours}
            testId="contact-card-hours"
          />
        </div>
      </div>
    </section>
  );
}

function ContactCard({ icon: Icon, label, value, href, testId }) {
  const Wrapper = href ? "a" : "div";
  const wrapperProps = href
    ? { href, target: href.startsWith("http") ? "_blank" : undefined, rel: "noreferrer" }
    : {};
  return (
    <Wrapper
      {...wrapperProps}
      data-testid={testId}
      className="card-glow block bg-[#12141C] border border-white/5 rounded-sm p-6 hover:border-[#00F0FF]/25 transition-colors"
    >
      <div className="h-9 w-9 rounded-sm bg-[#00F0FF]/10 border border-[#00F0FF]/20 grid place-items-center mb-5">
        <Icon className="h-4 w-4 text-[#00F0FF]" strokeWidth={1.5} />
      </div>
      <div className="text-[10px] uppercase tracking-[0.22em] text-white/50">
        {label}
      </div>
      <div className="mt-2 font-heading text-base text-white font-medium leading-snug">
        {value}
      </div>
    </Wrapper>
  );
}
